import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d09b88c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card bg-light booking-section" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-9" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Scheduling")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "col-md-3 text-right"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "alert-text blink_me",
  style: {"vertical-align":"sub"}
}, "Booking time has changed. Resend notifications.", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Who", -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-1" }
const _hoisted_14 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  height: "1.2em",
  viewBox: "0 0 512 512"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_18 = { class: "col-md-4 mt-auto mb-auto pr-0 text-wrap" }
const _hoisted_19 = { class: "col-md-1 pl-1 pr-0 mt-auto mb-auto" }
const _hoisted_20 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  height: "1.2em",
  viewBox: "0 0 512 512"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "col-md-2 pl-1 pr-0" }
const _hoisted_24 = {
  key: 0,
  class: "fa-stack fa-1x"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star fa-stack-1x rating-start" }, null, -1))
const _hoisted_26 = { class: "fa-stack-1x rating-text" }
const _hoisted_27 = { class: "col-md-5" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Timing", -1))
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-5 pr-0" }
const _hoisted_32 = { class: "col-md-12" }
const _hoisted_33 = { class: "col-md-12" }
const _hoisted_34 = { class: "col-md-5 pl-0" }
const _hoisted_35 = { class: "col-md-12" }
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = {
  key: 0,
  class: "row"
}
const _hoisted_38 = {
  key: 0,
  class: "col-md-10"
}
const _hoisted_39 = {
  key: 1,
  class: "col-md-10"
}
const _hoisted_40 = { class: "col-md-2" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Recommended time", -1))
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-md-12" }
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "col-md-2" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Appointment time", -1))
const _hoisted_49 = { class: "row" }
const _hoisted_50 = {
  key: 0,
  class: "col-md-3 pl-0 pr-0"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-alt" }, null, -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  key: 0,
  class: "row"
}
const _hoisted_54 = { class: "col-md-12" }
const _hoisted_55 = {
  key: 0,
  class: "row"
}
const _hoisted_56 = { class: "col-md-12" }
const _hoisted_57 = { class: "row h5" }
const _hoisted_58 = { class: "col-md-1 text-left" }
const _hoisted_59 = {
  key: 0,
  class: "mt-auto mb-auto"
}
const _hoisted_60 = {
  key: 0,
  class: "fas fa-2x fa-bicycle mr-5",
  "data-tooltip": "Bike"
}
const _hoisted_61 = {
  key: 1,
  class: "fas fa-2x fa-car mr-5",
  "data-tooltip": "Car"
}
const _hoisted_62 = {
  key: 2,
  class: "train-icon flag-icon",
  style: {"width":"30px","height":"30px","background-size":"30px 30px"},
  "data-tooltip": "Train"
}
const _hoisted_63 = {
  key: 3,
  class: "fas fa-2x fa-walking mr-5",
  "data-tooltip": "Walking"
}
const _hoisted_64 = {
  class: "col-md-5 text-right",
  style: {"margin":"auto 0"}
}
const _hoisted_65 = { key: 0 }
const _hoisted_66 = ["data-tooltip"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_68 = { class: "multiselecttag ml-1 mr-1" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_70 = ["data-tooltip"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_72 = { class: "multiselecttag ml-1 mr-1" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_74 = ["data-tooltip"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_76 = { class: "multiselecttag ml-1 mr-1" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_78 = { key: 1 }
const _hoisted_79 = ["data-tooltip"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_81 = { class: "multiselecttag ml-1 mr-1" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_83 = ["data-tooltip"]
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_85 = { class: "multiselecttag ml-1 mr-1" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_87 = { key: 2 }
const _hoisted_88 = ["data-tooltip"]
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_90 = { class: "multiselecttag ml-1 mr-1" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_92 = {
  class: "col-md-1 text-center",
  style: {"padding-left":"0px","padding-right":"0px"}
}
const _hoisted_93 = ["data-tooltip"]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-home fa-stack-1x",
  style: {"color":"#253746"}
}, null, -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "far fa-circle fa-stack-2x",
  style: {"color":"#dbd55a"}
}, null, -1))
const _hoisted_96 = [
  _hoisted_94,
  _hoisted_95
]
const _hoisted_97 = {
  class: "col-md-5 text-left",
  style: {"margin":"auto 0"}
}
const _hoisted_98 = { key: 0 }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_100 = { class: "multiselecttag ml-1 mr-1" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_102 = ["data-tooltip"]
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_104 = { class: "multiselecttag ml-1 mr-1" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_106 = ["data-tooltip"]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_108 = { class: "multiselecttag ml-1 mr-1" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_110 = ["data-tooltip"]
const _hoisted_111 = { key: 1 }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_113 = { class: "multiselecttag ml-1 mr-1" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_115 = ["data-tooltip"]
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_117 = { class: "multiselecttag ml-1 mr-1" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_119 = ["data-tooltip"]
const _hoisted_120 = { key: 2 }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_122 = { class: "multiselecttag ml-1 mr-1" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right ml-1 mr-1" }, null, -1))
const _hoisted_124 = ["data-tooltip"]
const _hoisted_125 = { class: "row h5" }
const _hoisted_126 = { class: "col-md-5 text-right" }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, null, -1))
const _hoisted_129 = {
  key: 0,
  class: "col-md-5 text-left"
}
const _hoisted_130 = { key: 0 }

import { computed, ref, onMounted, inject, watch, nextTick, onBeforeUnmount, onUnmounted, } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import moment from 'moment-timezone';
import _castArray from 'lodash/castArray';
import _get from 'lodash/get';
import BookingFixedTimeModal from "@/components/modals/BookingFixedTimeModal.vue";
import Ably from "ably";
import { Booking, Inspector, Report, Room, Schedule, Section, SelectOption, TravelTime, Type, Location, Customer, PresetError, DistanceMatrixResponse, DistanceMatrixRow, DistanceMatrixElement, TextValueObject } from '@/models';
import defaultschedules from "@/store/inspectors/json/schedules.json";
import { postfixTime } from "@/utilities";
import TravelTimeCircle from "@/components/diary/TravelTimeCircle.vue";
import TravelTimeHome from "@/components/diary/TravelTimeHome.vue";
import { InspectorTravelTime } from '@/models/diary/inspectortraveltime.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'Scheduling',
  setup(__props) {

const store = useStore();
const route = useRoute();
const realtime: Ably.Realtime = inject('realtime');
const actProperty: any = inject('actProperty'); // Injected property
const channel = realtime.channels.get('diary');
const deviceid = actProperty.getDeviceId();

const expanded = ref(false);

const inspectorsearchfilter = ref('');
const starttimeoptions = ref([]);
const endtimeoptions = ref([]);
const appointmenttimeoptions = ref([]);

const bookingFixedTimeModal = ref(null);
const dynamicRefs = ref({});

const traveltime = ref<TravelTime>(new TravelTime);
const calculatingtraveltime = ref(false);

const booking = computed((): Booking => store.getters['diary/booking']);
const customer = computed((): Customer => store.getters['diary/customer']);
const inspectors = computed((): Inspector[] => store.getters['diary/inspectorlist']);
const inspector = computed((): Inspector => store.getters['diary/inspector']);
const isQCuser = computed(() => store.getters['auth/isQCUser']);
const isBookingManagement = computed(() => store.getters['auth/isBookingManagement']);
const startdate = computed(() => store.getters['diary/startdate']);
const enddate = computed(() => store.getters['diary/enddate']);
const recommendedappointmenttime = computed(() => store.getters['diary/recommendedappointmenttime']);
const currentdate = computed(() => store.getters['diary/currentdate']);
const recommendedtime = computed(() => store.getters['diary/recommendedtime']);
const appointmenttime = computed(() => store.getters['diary/appointmenttime']);
const hasBlockingRequests = computed(() => store.getters['app/hasBlockingRequests']);
const setInspector = (inspector) => {
  store.commit('diary/setInspector', inspector);
};
const disableddatewatch = computed(() => {
  return moment(currentdate.value).format("YYYY-MM-DD") === '2050-12-31' ? true : false;
});

const setStateStartdate = (startdate) => {
  store.commit('diary/setStartdate', startdate);
};

const setStateEnddate = (enddate) => {
  store.commit('diary/setEnddate', enddate);
};

const setStateRecommendedtime = (recommendedtime) => {
  store.commit('diary/setRecommendedtime', recommendedtime);
};

const publishNewbookingdetails = () => {
  // Step 1 - calculating the travel time for a new booking
  // Filtering criteria
  // Only PIâ€™s who are 3 star for the given postcode prefix of the new booking, exclude 2 and 1 star
  // If the PI did the previous linked report, even if not 3 star
  // If the PI already has bookings in that postcode area, even if not 3 star
  // If the above filtering provides no responses, then open up criteria to include 2 star.
  let toppilist: string[] =  [];
  for(let i = 0; i < inspectorlist.value.length; i++) {
    const selectoption = inspectorlist.value[i];
    let rating = getRating({slug:selectoption.slug});
    if(i < 6 || rating === 3) {
      const insp = inspectors.value.find((i)=> i.id === selectoption.slug);
      if(insp) {
        toppilist.push(insp.id);
      }
    }
  }

  let formcurrentdate = moment(currentdate.value).utc().format("YYYY-MM-DD");
  channel.publish('newbookingdetails', 
    { deviceid: deviceid,
      newbookingid: booking.value.id, 
      formcurrentdate: formcurrentdate,
      recommendedtime: recommendedtime.value, 
      startpostcodes: booking.value.startpostcodes, 
      endpostcodes:  booking.value.endpostcodes,
      toppilist: toppilist,
    });
}

const setStateAppointmenttime = (appointmenttime) => {
  store.commit('diary/setAppointmenttime', appointmenttime);
};

const setBookingDeep = async (payload): Promise<any> => {
  return await store.dispatch('diary/setBookingDeep', payload);
};

const sortInpectorsInState = async (params): Promise<any> => {
  return await store.dispatch('diary/sortInpectors', params);
};

const getBookingsForPI = async (params): Promise<Booking[]> => {
  return await store.dispatch('diary/getBookingsForPI', params);
}

const getDistanceMatrix = async (params): Promise<DistanceMatrixResponse> => {
  return await store.dispatch('diary/getDistanceMatrix', params);
}

onMounted(() => {
  Promise.all([setStartTimeOptions(), setEndTimeOptions()])
    .then((values) => {})
    .catch((err) => {
      actProperty.displayError(err);
    });
  
  channel.subscribe('commoncovertapplied', (message: any) => {
    if(message?.data) {
      // Make sure the event is coming from the same pc
      if(message.data.deviceid != deviceid) return;
      if(message.data.bookingid != booking.value.id) return;
      // Sort inspectors based on previous booking selection
      sortInspectors();
    }
  });
});

onBeforeUnmount(() => {
  channel.unsubscribe('commoncovertapplied');
});

const sortInspectors = () => {
  sortInpectorsInState({
    previousreport: booking.value?.basereport,
    previousbooking: booking.value?.previousbooking,
    postcode: booking.value?.address?.postcode,
  });
}

const inspectorlist = computed((): SelectOption[] => {
  return inspectors.value
    .filter((i: Inspector) => !i.inactive && i.name.toLowerCase() != "default")
    .filter((i: Inspector) => {
      if(inspectorsearchfilter.value)
        return i.name.toLowerCase().startsWith(inspectorsearchfilter.value.toLowerCase());
      else
        return true;
    })
    .map((i) => new SelectOption({ name: i.name, slug: i.id }));
});

const _inspector = computed({
  get: () => {
    let insp = inspectors.value.find((i) => i.id == inspector.value.id);
    return new SelectOption({ name: insp?.name, slug: insp?.id });
  },
  set: (val: SelectOption) => {
    if (val) {
    let insp = inspectors.value.find((i) => i.id == val.slug);
    if (insp) {
      setInspector(insp);
    }
  }
  }
});

const resetInspector = () => {
  setInspector(new Inspector());
}

const setStartTimeOptions = () => {
  starttimeoptions.value = [];
  let startmoment = moment().set("hour", 6).set("minute", 0);
  appointmenttimeoptions.value.push("No Tenant but Fixed Time");
  appointmenttimeoptions.value.push("Flexi all day");
  appointmenttimeoptions.value.push("Flexi AM");
  appointmenttimeoptions.value.push("Flexi PM");
  for (let i = 0; i < 62; i++) {
    const hourMinutes = startmoment.format("hh:mm A");
    starttimeoptions.value.push(hourMinutes);
    appointmenttimeoptions.value.push(hourMinutes);
    startmoment.add(15, "minutes");
  }
}

const setEndTimeOptions = () => {
  endtimeoptions.value = [];
  let startmoment = moment().set("hour", 6).set("minute", 0);
  if (_startdate.value) {
    startmoment = moment(_startdate.value, "hh:mm A");
    startmoment.add(15, "minutes");
  }
  for (let i = 0; i < 62; i++) {
    const hourMinutes = startmoment.format("hh:mm A");
    endtimeoptions.value.push(hourMinutes);
    startmoment.add(15, "minutes");
    if (hourMinutes === "9:00 PM ") break;
  }
};

const _startdate = computed({
  get: () => {
    let value = startdate.value
      ? moment(startdate.value).utc().format("hh:mm A")
      : "";
    const index = starttimeoptions.value.findIndex(
      (option: string) => option === value
    );
    if (index < 0) value = "";
    return value;
  },
  set: (val: string) => {
    setStateStartdate(
      actProperty.prependDate(val, startdate.value, currentdate.value)
    );
    determineEnddate();

    // Only determine appointmenttime for a new booking
    if(!booking.value.appointmentconfirmationsent) determineAppointmenttime();
  }
});


watch(() => _startdate.value, (newVal) => {
  setEndTimeOptions();
});

const _enddate = computed({
  get: () => {
    let value = enddate.value
      ? moment(enddate.value).utc().format("hh:mm A")
      : "";
    const index = endtimeoptions.value.findIndex(
      (option: string) => option === value
    );
    if (index < 0) value = "";
    return value;
  },
  set: (val: string) => {
    setStateEnddate(
      actProperty.prependDate(val, startdate.value, currentdate.value)
    );
    if(!startdate.value || actProperty.isFiveam(startdate.value))
      determineStartdate();
    let duration = booking.value.duration;
    if (duration === recommendedtime.value) duration = 0;
    setBookingDeep({
      path: "preferredduration",
      data: duration,
    });

    /*let enddateMoment = moment(enddate.value).utc();
    let selectetimeMoment = moment(this.appointmenttime).utc()
    let inmiutesfromenddate = moment
        .duration(enddateMoment.diff(selectetimeMoment))
        .asMinutes();
    let recommendedappointmenttime = recommendedappointmenttime.value;
    if(recommendedappointmenttime != inmiutesfromenddate)
      setBookingDeep({path: "preferredappointmenttime", data: inmiutesfromenddate});
    else
      setBookingDeep({path: "preferredappointmenttime", data: 0});*/

    // Only determine appointmenttime for a new booking
    if(!booking.value.appointmentconfirmationsent) {
      determineAppointmenttime();
    }
  }
});

const clearPreferredduration = () => {
  setBookingDeep({
    path: "preferredduration",
    data: 0,
  });

  if(!actProperty.isFiveam(startdate.value)) {
    determineEnddate();
  }
  else {
    setStateEnddate(actProperty.getFilveam());
  }
}

const determineStartdate = () => {
  if (enddate.value && _recommendedtime.value) {
    setStateStartdate(
      actProperty.prependDate(
        moment(enddate.value).utc().subtract(recommendedtime.value, "minutes").format("hh:mm A"),
        enddate.value,
        currentdate.value
      )
    );
  }
}

const determineEnddate = () => {
  if(bypassautodetermination.value) {
    return;
  }

  if (startdate.value && _recommendedtime.value) {
    let time =
      booking.value.preferredduration > 0
        ? booking.value.preferredduration
        : recommendedtime.value;
    setStateEnddate(
      actProperty.prependDate(
        moment(startdate.value).utc().add(time, "minutes").format("hh:mm A"),
        startdate.value,
        currentdate.value
      )
    );
  }
}

const determineAppointmenttime = () => {
  //let existingappointmenttime = moment(this.appointmenttime)
  //  .utc()
  //  .format("hh:mm A");
  // Only change appointmenttime if this is not an existing booking
  // exception 1: to this rule - allow change if appointment falls ourside the booking time
  // exception 2: to this rule - allow change if appointment is 'No Tenant but Fixed Time' (12:00 AM)
  /*if (
    booking.value.id &&
    !booking.value.appointmenttimeoutsidebooking &&
    "12:00 AM" != existingappointmenttime
  )
    return;*/

  if(bypassautodetermination.value) {
    return;
  }

  // If in absence flag is on for this customer then do not auto determine appointment time
  let inabs = (booking.value.customer?.policies?.inspectioninabs);
  if(inabs) return;

  let appointmenttime = "";
  let timeinminutes = 0;
  if (booking.value.preferredappointmenttime > 0)
    timeinminutes = booking.value.preferredappointmenttime;
  else if (recommendedappointmenttime.value > 0)
    timeinminutes = recommendedappointmenttime.value;

  // Round it to the nearest 15 minutes interval
  timeinminutes = Math.round(timeinminutes / 15) * 15;
  if (enddate.value && timeinminutes > 0) {
    appointmenttime = moment(enddate.value)
      .utc()
      .subtract(timeinminutes, "minutes")
      .format("hh:mm A");
  } else if (startdate.value) {
    appointmenttime = moment(startdate.value).utc().format("hh:mm A");
  }
  setStateAppointmenttime(
    actProperty.prependDate(
      appointmenttime,
      startdate.value,
      currentdate.value
    )
  );
}

// If new booking - do not bypass
// If flexi or Master with a PREP or startdatenotset - bypass
const bypassautodetermination = computed(() => {
  if(isNewBooking()) return false;
  let prepfound = false;
  let sub: Booking | undefined = undefined;
  if (booking.value.subbookings?.length) {
    sub = booking.value.subbookings.find(
      (b: Booking) => b.subtype === Booking.PREP
    );
  }
  prepfound = sub?.id ? true : false;
  let flexi = (_appointmenttime.value === 'No Tenant but Fixed Time' 
    || _appointmenttime.value.startsWith('Flexi'));

  let startdatenotset = actProperty.isFiveam(startdate.value);
  return prepfound || flexi || startdatenotset;
});

const _recommendedtime = computed(() => {
  return convertToHoursMinutes(recommendedtime.value);
});

const _preferredduration = computed(() => {
  if (recommendedtime.value > booking.value.preferredduration) {
    return convertToHoursMinutes(
      recommendedtime.value - booking.value.preferredduration
    );
  } else {
    return convertToHoursMinutes(
      booking.value.preferredduration - recommendedtime.value
    );
  }
});

const convertToHoursMinutes = (val: number) => {
  let hourMinutes = moment
    .utc()
    .startOf("day")
    .add(val, "minutes")
    .format("HH [Hours] mm [Minutes]");
  hourMinutes = hourMinutes.replaceAll("00 Hours", "");
  hourMinutes = hourMinutes.replaceAll("00 Minutes", "");
  return hourMinutes;
}

const _appointmenttime = computed({
  get: (): string => {
    let time =
      booking.value.preferredappointmenttime > 0
        ? booking.value.preferredappointmenttime
        : appointmenttime.value;
    let apptime = time
      ? moment(appointmenttime.value).utc().format("hh:mm A")
      : "";
    if (apptime === "12:00 AM") apptime = "No Tenant but Fixed Time";
    if (apptime === "12:15 AM") apptime = "Flexi all day";
    if (apptime === "12:20 AM") apptime = "Flexi AM";
    if (apptime === "12:25 AM") apptime = "Flexi PM";
    const index = appointmenttimeoptions.value.findIndex(
      (option: string) => option === apptime
    );
    if (index < 0) apptime = "";
    return apptime;
  },
  set: (val: string) => {
    if (val === "No Tenant but Fixed Time") {
      setBookingDeep({
        path: "preferredappointmenttime",
        data: 0,
      });
      setStateAppointmenttime(
        actProperty.prependDate(
          "12:00 AM",
          startdate.value,
          currentdate.value
        )
      );
      showFixedTimeModal();
    } else if (val === "Flexi all day") {
      setBookingDeep({
        path: "preferredappointmenttime",
        data: 0,
      });
      setStateAppointmenttime(
        actProperty.prependDate(
          "12:15 AM",
          startdate.value,
          currentdate.value
        )
      );
    } else if (val === "Flexi AM") {
      setBookingDeep({
        path: "preferredappointmenttime",
        data: 0,
      });
      setStateAppointmenttime(
        actProperty.prependDate(
          "12:20 AM",
          startdate.value,
          currentdate.value
        )
      );
    } else if (val === "Flexi PM") {
      setBookingDeep({
        path: "preferredappointmenttime",
        data: 0,
      });
      setStateAppointmenttime(
        actProperty.prependDate(
          "12:25 AM",
          startdate.value,
          currentdate.value
        )
      );
    } else {
      if (!val) val = "0:00 AM";
      let startdateMoment = moment(startdate.value).utc();
      let enddateMoment = moment(enddate.value).utc();
      let selectedTime = postfixTime(
        enddate.value,
        moment(val, "hh:mm A").format(actProperty.bookingdateutcformat)
      );
      let selectetimeMoment = moment(selectedTime).utc();
      let inmiutesfromenddate = moment
          .duration(enddateMoment.diff(selectetimeMoment))
          .asMinutes();

      if(booking.value.id) {        
        // For an existing booking just set the time
        setBookingDeep({
          path: "preferredappointmenttime",
          data: inmiutesfromenddate,
        });
        setBookingDeep({
          path: "appointmenttime",
          data: actProperty.prependDate(val, startdate.value)
        });
      }
      else {
        // For a new appointment rely on determineAppointmenttime
        let inmiutesfromstartdate = moment
          .duration(startdateMoment.diff(selectetimeMoment))
          .asMinutes();

        // If reccommendedtime is selected, then just reset override
        // if time before starttime is selected, don't allow
        if (inmiutesfromstartdate <= 0 && inmiutesfromenddate >= 0) {
          if (inmiutesfromenddate === recommendedappointmenttime.value)
            inmiutesfromenddate = 0;
          setBookingDeep({
            path: "preferredappointmenttime",
            data: inmiutesfromenddate,
          });
          determineAppointmenttime();
        }
      }
    }
  }
});

const recommendedappointmenttimeAsHHMM = computed((): string => {
  let appointmenttime: string = "";
  if (enddate.value && recommendedappointmenttime.value > 0) {
    appointmenttime = moment(enddate.value)
      .utc()
      .subtract(recommendedappointmenttime.value, "minutes")
      .format("hh:mm A");
  } else if (startdate.value) {
    appointmenttime = moment(startdate.value).utc().format("hh:mm A");
  }
  return appointmenttime;
});

const clearPreferredappointmenttime = () => {
  setBookingDeep({path: "preferredappointmenttime",data: 0,});
  //determineAppointmenttime();
  setStateAppointmenttime('');
}

watch(() => recommendedappointmenttime.value, () => {
  if (!actProperty.isFiveam(startdate.value) && !actProperty.isFiveam(enddate.value)) {
    if (booking.value.preferredduration === 0) determineEnddate();
    if (!booking.value.appointmentconfirmationsent && booking.value.preferredappointmenttime === 0) {
      determineAppointmenttime();
    }
  }
});

const bookingwatch = computed(() => {
  let value = `${booking.value.inspector.id},${booking.value.internaljobtype},${booking.value.startdate},${booking.value.propertytypegroup}`;
  if (booking.value?.basereport) {
    if (booking.value?.basereport?.firstexportedby)
      value = `${value},${booking.value?.basereport.firstexportedby}`;
    if (booking.value?.basereport.date)
      value = `${value},${booking.value.basereport.date}`;
  }
  return value;
});

watch(() => bookingwatch.value, () => {
  setStateRecommendedtime(0);
  determineRecommendedtime();

  if (booking.value.preferredduration === 0 && !actProperty.isFiveam(startdate.value)) determineEnddate();

  // Following code is adding a lot of complexity
  // Uncommeting for now to see if it works!
  if (!actProperty.isFiveam(startdate.value) && !actProperty.isFiveam(enddate.value)) {
    if (!booking.value.appointmentconfirmationsent && booking.value.preferredappointmenttime === 0) {
      determineAppointmenttime();
    }
  }
});

const determineRecommendedtime = () => {
  // If this is a CO - CO off ACT Report
  // User previous report itemcount rule to determine recommendedtime
  // Trello - https://trello.com/c/qN6GnHHP/554-timing-of-jobs
  if(booking.value.jobtype === 'checkout' 
    && booking.value.internaljobtype === 'Check-Out - off ACT report'
    && basereportitemcount.value > 0) {
      let timeinminutes =Math.round(basereportitemcount.value * 0.6)
      timeinminutes = Math.ceil(timeinminutes / 15) * 15;
      setStateRecommendedtime(timeinminutes);
  }
  else if (booking.value.inspector) {
    let inspectorschedules: Schedule[] = [];
    if (
      !booking.value.inspector.schedules ||
      booking.value.inspector.schedules.length == 0
    ) {
      inspectorschedules = _castArray(
        _get(defaultschedules, "schedules", [])
      ).map((r: any) => new Schedule(r));
    } else {
      inspectorschedules = booking.value.inspector.schedules;
    }
    let filtereddefaultschedules = defaultschedules.schedules.filter(
      (schedule) => {
        let i = schedule.internaljobtypelist?.findIndex(
          (t) => t === booking.value.internaljobtype
        );
        return i >= 0 ? true : false;
      }
    );
    if (filtereddefaultschedules.length) {
      let searchreoprttype: string = "";
      if (filtereddefaultschedules.length == 1) {
        searchreoprttype = filtereddefaultschedules[0].reporttype;
      } else if (filtereddefaultschedules.length > 1) {
        let offactreport = false;
        let bysamepi = false;
        if (booking.value?.basereport?.id || booking.value?.previousbooking?.id) {
          offactreport = true;
          if (
            booking.value?.basereport?.firstexportedby &&
            booking.value?.basereport?.firstexportedby ===
              booking.value.inspector.email
          ) {
            bysamepi = true;
          }
          else if(booking.value?.previousbooking?.inspector &&
            booking.value?.previousbooking?.inspector?.id ===
              booking.value.inspector.id) {
            bysamepi = true;
          }

          let postfix = "";
          if (offactreport) postfix = " - off ACT report";

          let offupload =
            booking.value.internaljobtype === "Check-In - off upload";
          if (offupload) postfix = " - off upload";

          if (bysamepi) postfix = `${postfix} - same PI as at CO`;

          let reportdate = '';
          if(booking.value?.basereport?.id) reportdate = booking.value?.basereport.date;
          else if(booking.value?.previousbooking?.id) reportdate = booking.value?.previousbooking.bookingdate;
          let startdate = booking.value.startdate;
          if (!startdate)
            startdate = moment(currentdate.value)
              .utc()
              .format(actProperty.bookingdateformat);
          const date1: any = moment(
            reportdate,
            actProperty.bookingdateformat
          )
            .utc()
            .startOf("day");
          const date2: any = moment(
            startdate,
            actProperty.bookingdateformat
          )
            .utc()
            .startOf("day");

          // 1+ month ago
          if (
            moment(date2).subtract(1, "months").isSameOrAfter(moment(date1))
          ) {
            searchreoprttype = `Check-In following Check-Out 1+ month ago${postfix}`;
          }
          // less than 1 month greater than 48 hours ago
          else if (
            moment(date2).subtract(1, "months").isBefore(moment(date1)) &&
            moment(date2).subtract(2, "days").isSameOrAfter(moment(date1))
          ) {
            searchreoprttype = `Check-In following Check-Out less than 1 month greater than 48 hours ago${postfix}`;
          }
          // less than 48 hours ago
          else if (
            moment(date2).subtract(2, "days").isBefore(moment(date1)) &&
            moment(date2).subtract(1, "days").isSameOrAfter(moment(date1))
          ) {
            searchreoprttype = `Check-In following Check-Out less than 48 hours ago${postfix}`;
          }
          // less than 24 hours ago
          else if (
            moment(date2).subtract(1, "days").isBefore(moment(date1))
          ) {
            searchreoprttype = `Check-In following Check-Out less than 24 hours ago or following an Inventory Prep - off ACT report or upload`;
            if (bysamepi)
              searchreoprttype =
                searchreoprttype + " and same PI";
          }
        }
      }      
      if(!searchreoprttype && booking.value.jobtype === 'checkin') {        
        // In case where we could not determine the schedule grouping for CI
        // we are to use the first (worst case scenario) as our default grouping
        searchreoprttype = 'Check-In following Check-Out 1+ month ago - off ACT report';
      }

      if (searchreoprttype) {
        var schedule: Schedule | undefined = inspectorschedules.find(
          (s) => s.reporttype === searchreoprttype
        );
        if(!schedule) {
          const scheduleObj: any = defaultschedules.schedules.find(
            (s) => s.reporttype === searchreoprttype
          );
          schedule = new Schedule(scheduleObj);
        }
        if (schedule && schedule.timinggroups) {
          const propertytypegroup = booking.value.propertytypegroup;
          if (propertytypegroup) {
            schedule.timinggroups.forEach((tg) => {
              if (tg.propertytypegroup) {
                var timing = tg.propertytypegroup.find((ptg) => {
                  // This is to correct an unfortunate spelling mistake made in the default schedulers
                  const type = ptg.propertytype.replaceAll(
                    "Frunished",
                    "Furnished"
                  );
                  return type === propertytypegroup;
                });

                if(!timing) {
                  // Search in default
                  timing = tg.propertytypegroup.find((ptg) => ptg.propertytype === 'default');
                }

                if (timing) {
                  let rectime = timing.timing;
                  let itemcount = basereportitemcount.value;
                  if(timing.minutesperitem &&  itemcount > 0) {
                    rectime = (itemcount/100) * timing.minutesperitem;
                    // Round to the next 15 mins
                    rectime = Math.round(rectime / 15) * 15;
                    if(timing.tenanttoarriveafter) {
                      rectime += timing.tenanttoarriveafter;
                    }
                  }
                  setStateRecommendedtime(rectime);

                  // For check out recommendedappointmenttime is always 0
                  let _recommendedappointmenttime = 0;
                  if (booking.value.jobtype != "check out" && booking.value.jobtype != "soc")
                    _recommendedappointmenttime = timing.tenanttoarriveafter;
                  setBookingDeep({
                    path: "recommendedappointmenttime",
                    data: _recommendedappointmenttime,
                  });
                }
              }
            });
          }
        }
      }
    }
  }
}

const basereportitemcount = computed(() => {
  let itemcount = 0;
  if (booking.value?.basereport && booking.value?.basereport)
    itemcount = countitems(booking.value?.basereport);
  else if (booking.value?.dataentryreport && booking.value?.dataentryreport)
    itemcount = countitems(booking.value?.dataentryreport);
  return itemcount;
});
const countitems = (report: Report) => {
  let itemcount = 0;
  report.rooms.forEach((r: Room) => {
    r.sections.forEach((s: Section) => {
      s.types.forEach((t: Type) => {
        itemcount += t.items.length;
      });
    });
  });
  return itemcount;
}

const copyToClipboard = (val: string) => {
  const selBox = document.createElement("textarea");
  selBox.style.position = "fixed";
  selBox.style.left = "0";
  selBox.style.top = "0";
  selBox.style.opacity = "0";
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand("copy");
  document.body.removeChild(selBox);
}

const ratingmap: Map<string, Map<string, number>> = new Map<string, Map<string, number>>();
const getRating = (option: any): number => {
  let inspector: Inspector | undefined = undefined;
  if (option && option.slug) {
    inspector = inspectors.value.find((i: Inspector) => i.id === option.slug);
  }
  let rating: number = 0;
  if (
    inspector &&
    inspector.locations &&
    inspector.locations.length &&
    booking.value?.address?.postcode
  ) {
    let postcode = booking.value.address.postcode;
    postcode = postcode.replace(/ /g, "");
    let inspratingmap: Map<string, number> = ratingmap.get(inspector.id);
    if(inspratingmap) {
      let rating = inspratingmap.get(postcode);
      if(rating >= 0) {
        return rating;
      }
    }
    let areacode = postcode.substring(0, postcode.length - 3);
    if (areacode) {
      let location: Location | undefined = inspector.locations.find(
        (l: Location) => l.code.trim() === areacode.trim()
      );
      if (location) rating = location.rating;
    }
    if(!inspratingmap) {
      inspratingmap = new Map<string, number>();
      ratingmap.set(inspector.id, inspratingmap);
    }
    inspratingmap.set(postcode, rating);
  }
  return rating;
}

const previousPI = (option: any): boolean => {
  let inspector: Inspector | undefined = undefined;
  if (option && option.slug) {
    inspector = inspectors.value.find((i: Inspector) => i.id === option.slug);
  }
  let previousreportdonebysamepi: boolean = false;
  if (
    inspector &&
    booking.value?.basereport &&
    (booking.value?.basereport?.firstexportedby || booking.value?.basereport?.user)
  ) {
    previousreportdonebysamepi = (inspector.email === booking.value?.basereport?.firstexportedby || inspector.email === booking.value?.basereport?.user);
  }
  let previousbookingdonebysamepi: boolean = false;
  if (
    inspector &&
    booking.value?.previousbooking &&
    (booking.value?.previousbooking?.inspector?.id)
  ) {
    const previousbookingmoment = moment(booking.value.previousbooking.startdate).utc();
    const bookingmoment = moment(booking.value.startdate).utc();
    if(previousbookingmoment.isBefore(bookingmoment))
      previousbookingdonebysamepi = inspector.id === booking.value?.previousbooking?.inspector?.id;
  }
  return previousreportdonebysamepi || previousbookingdonebysamepi;
}

const getPiNameColClass = (option: any) => {
  let rating = getRating(option);
  let previous = previousPI(option);
  let columns = 11;
  if (rating) columns -= 4;
  if (previous) columns -= 1;

  let st = `col-md-${columns}`;
  const excluded = isPIExcludedOrPreferred(option);
  if(excluded) st = `${st} ${excluded}`;

  return st
}

const inspectorAreacount = (option: any): string => {
  let inspector: Inspector | undefined = getInspector(option);
  let count: number = 0;
  if (inspector) {
    count = inspector.getAreacount(booking.value?.address?.postcode);
  }
  return count > 0 ? `In area x ${count}` : "";
}

const getInspector = (option: any): Inspector => {
  let inspector: Inspector | undefined = undefined;
  if (option && option.slug) {
    inspector = inspectors.value.find((i: Inspector) => i.id === option.slug);
  }
  return inspector;
}

const schedulealert = computed(() => {
  return booking.value.propertytypegroup && !recommendedtime.value;
});

const dropDownOpened = (ref: string) => {
  nextTick(() => {
    // Get the reference to the dropdown list container
    const multiselect = dynamicRefs.value[ref] as any;
    const dropdownList = multiselect.$el.querySelector('.multiselect__content-wrapper');

    // Get the reference to the selected option element
    const selectedOption = multiselect.$el.querySelector('.multiselect__option--selected');

    // Scroll to the position of the selected element
    if(selectedOption?.offsetTop)
      dropdownList.scrollTop = selectedOption.offsetTop - 120;
    else if(ref === 'startDateDropDown' || ref === 'endDateDropDown')
      dropdownList.scrollTop = 480;


    if(ref === 'inspectorDropDown') {
      const highlightedOption = multiselect.$el.querySelector('.multiselect__option--highlight');
      if(highlightedOption) {
        highlightedOption.classList.remove('multiselect__option--highlight');
      }
    }
  });
}

const showFixedTimeModal = () => {
  const modal = bookingFixedTimeModal.value as any;
  modal.init();
  
  modal.show();
}
const isNewBooking = () => {
  return route.params.id == "new";
}

const customLabel = (option: string) => {
  return option.replace(/^0/, '');
}

const isCustomerReportFlexOn = (option: string) => {
  // The setting is only applicable if Inspection in absence is on for selected customer
  if(!customer.value.policies.inspectioninabs) return false;

  let result = false;
  if (option === 'Flexi all day') {
    result = ((booking.value.jobtype === 'inventory' || booking.value.jobtype === 'checkin') && customer.value.policies.invciflex)
      || ((booking.value.jobtype === 'checkout' || booking.value.jobtype === 'soc') && customer.value.policies.cosocflex);
  }
  else if(option === 'Flexi AM') {
    result = ((booking.value.jobtype === 'inventory' || booking.value.jobtype === 'checkin') && customer.value.policies.invciflexam);
  }
  else if(option === 'No Tenant but Fixed Time') {
    result = true;
  }
  return result;
}

const isPIExcludedOrPreferred = (option: SelectOption) => {
  let inspector: Inspector | undefined = undefined;
  if (option && option.slug) {
    inspector = inspectors.value.find((i: Inspector) => i.id === option.slug);
  }
  if (
    inspector &&
    inspector.excludedclients &&
    inspector.excludedclients.length
  ) {
    const excludedindex = inspector.excludedclients.findIndex((c) => c.id === customer.value.id);
    if(excludedindex >= 0) return 'excluded';
  }
  if (
    inspector &&
    inspector.preferredclients &&
    inspector.preferredclients.length
  ) {
    const preferredindex = inspector.preferredclients.findIndex((c) => c.id === customer.value.id);
    if(preferredindex >= 0) return 'preferred';
  }
  return '';
}

const timeOutsideAgencyOpeningHours = (option: string) => {
  if(!customer.value.policies.openinghours?.length) return false;
  
  const dow = moment(booking.value.startdate).utc().day();
  const agencyclosed = customer.value.policies?.openinghours[dow-1]?.closed;
  const agencyopenfrom = customer.value.policies?.openinghours[dow-1]?.from;
  const agencyopento = customer.value.policies?.openinghours[dow-1]?.to;
  if(agencyclosed) return true;
  if (
    (agencyopenfrom &&
      agencyopento &&
      (moment.utc(option, 'hh:mm A').isBefore(moment.utc(agencyopenfrom, 'HH:mm'))) ||
      moment.utc(option, 'hh:mm A').isAfter(moment.utc(agencyopento, 'HH:mm')))
  ) {
    return true
  }
  return false;
}

const piselectionwatch = computed(() => {
  return `${currentdate.value},
    ${recommendedtime.value},
    ${booking.value.startpostcodes},
    ${booking.value.endpostcodes}`;
});
watch(() => piselectionwatch.value, async () => {
  if(booking.value.id) return;
  if(recommendedtime.value && booking.value.address.postcode)
    publishNewbookingdetails();
  // for(let i = 0; i < inspectorlist.value.length; i++) {
  //   const selectoption = inspectorlist.value[i];
  //   const insp = inspectors.value.find((i)=> i.id === selectoption.slug);
  //   if(insp) {
  //     insp.distancematrix = new DistanceMatrixResponse();
  //     insp.traveltime = new InspectorTravelTime();
  //   }
  // }
  // if(recommendedtime.value) {
  //   // Step 1 - calculating the travel time for a new booking
  //   // Filtering criteria
  //   // Only PIâ€™s who are 3 star for the given postcode prefix of the new booking, exclude 2 and 1 star
  //   // If the PI did the previous linked report, even if not 3 star
  //   // If the PI already has bookings in that postcode area, even if not 3 star
  //   // If the above filtering provides no responses, then open up criteria to include 2 star.
  //   for(let i = 0; i < inspectorlist.value.length; i++) {
  //     const selectoption = inspectorlist.value[i];
  //     let rating = getRating({slug:selectoption.slug});
  //     if(i < 6 || rating === 3) {
  //       const insp = inspectors.value.find((i)=> i.id === selectoption.slug);
  //       if(insp) {
  //         insp.traveltime = await prepareTravelTimeForPI(insp);
  //       }
  //     }
  //   }
  // }
});

// let traveltimeloadingmap: Map<string, boolean> = new Map<string, boolean>();
// async function loadSinglePiTravelTime(selectoption: SelectOption) {
//   const insp = inspectors.value.find((i)=> i.id === selectoption.slug);
//   if(insp) {
//     insp.traveltime = await prepareTravelTimeForPI(insp);
//   }
// }

// async function prepareTravelTimeForPI(pi: Inspector) {
//   let checkDate = moment(currentdate.value).utc().format("DD-MM-YYYY");
//   if (checkDate === '31-12-2050') return;
//   traveltimeloadingmap.set(pi.id, true);
//   let traveltime: InspectorTravelTime = new InspectorTravelTime();
  
//   const pibookings: Booking[] = await getBookingsForPI({
//     date: checkDate, 
//     inspectorid: pi.id, fieldlist:"id,startdate,enddate,jobtype,all_day,address,recurrence_rule",
//     period: 'days',
//   });

//   let currentdatevalue = moment(currentdate.value).utc().format('YYYY-MM-DD');
//   const filteredBookings = pibookings.filter(b =>  {
//     if(!b.jobtype) return false;
//     if(b.allDay) return false;
//     let bookingstartdate = moment(b.startdate).utc().format('YYYY-MM-DD');

//     if(b.recurrenceRule) {
//       // Check if this recurring event is falling on to today
//       traveltimeloadingmap.set(pi.id, false);
//       return b.checkRecurrance(currentdate.value)
//     }
//     else {
//       traveltimeloadingmap.set(pi.id, false);
//       return bookingstartdate === currentdatevalue;
//     }
//   });
//   filteredBookings.sort((a, b) => moment.utc(a.starttime, "h:mm a").diff(moment.utc(b.starttime, "h:mm a")));

//   const startOfDay = "09:00";
//   let firstjobviable = findViableGap(startOfDay, filteredBookings, recommendedtime.value, null, null);
//   if(firstjobviable === startOfDay) {
//     traveltime.fromhomestarttime = prepareViableTimeGrapRespose(firstjobviable, recommendedtime.value);
//     traveltime.fromhome = await googleTravelTime(pi?.address?.postcode, booking.value.startpostcode, pi?.travelmode);
//   }
//   else {
//     traveltime.fromhomestarttime = "";
//     traveltime.fromhome = await googleTravelTime(pi?.address?.postcode, booking.value.startpostcode, pi?.travelmode);
//   }

//   for(let i = 0; i < filteredBookings.length; i++) {
//     let pibooking = filteredBookings[i];

//     // if both start and end postcodes are missing, don't calculate
//     if(!pibooking.startpostcode && !pibooking.endpostcode) continue;

//     let tobooking = -1;
//     let tobookingstarttime = "";
//     let frombooking = -1;
//     let frombookingstarttime = "";

//     // Calculate traveltime from new booking to pi booking
//     const gaponleft = findViableGap(startOfDay, filteredBookings, recommendedtime.value, pibooking.id, "left");
//     if(gaponleft) {
//       let duration = await googleTravelTime(booking.value.endpostcode, pibooking.startpostcode, pi?.travelmode);
//       let gapstartminutes = timeToMinutes(gaponleft);
//       let newstartinminutes =  Math.round((gapstartminutes - duration) / 15) * 15;
//       tobookingstarttime = minutesToTime(newstartinminutes);
//       tobooking = duration;
//     }

//     //  Calculate traveltime from pi booking to new booking
//     const gaponright = findViableGap(startOfDay, filteredBookings, recommendedtime.value, pibooking.id, "right");
//     if(gaponright) {
//       let duration = await googleTravelTime(pibooking.endpostcode,booking.value.startpostcode, pi?.travelmode);
//       let gapstartminutes = timeToMinutes(gaponright);
//       let newstartinminutes =  Math.round((duration + gapstartminutes) / 15) * 15;
//       frombookingstarttime = minutesToTime(newstartinminutes);
//       frombooking = duration;
//     }

//     if(tobooking || tobookingstarttime || frombooking || frombookingstarttime) {
//       let bookingtime = convertDateRange(pibooking.startdate,pibooking.enddate)
//       traveltime.bookingtime.push(bookingtime);
//       traveltime.tobooking.push(tobooking);
//       let tobookingtime = prepareViableTimeGrapRespose(tobookingstarttime, recommendedtime.value);
//       traveltime.tobookingstarttime.push(tobookingtime);
//       traveltime.frombooking.push(frombooking);
//       let frombookingtime = prepareViableTimeGrapRespose(frombookingstarttime, recommendedtime.value);
//       traveltime.frombookingstarttime.push(frombookingtime);
//     }
//   }
//   traveltimeloadingmap.set(pi.id, false);
//   return traveltime;
// }

// Function to convert ISO 8601 date strings to a readable time range
// function convertDateRange(fromDate, toDate) {
//   // Parse the from and to dates using moment
//   const start = moment(fromDate).utc();
//   const end = moment(toDate).utc();

//   // Format the times as desired (e.g., "hh:mm A" for 24-hour format)
//   const formattedStart = start.format('HH:mm');
//   const formattedEnd = end.format('HH:mm');

//   return `${formattedStart} - ${formattedEnd}`;
// }

// function getInspectorTravelTimeLoading(option: SelectOption) {
//   let result = false;
//   if(traveltimeloadingmap.get(option.slug)) {
//     result = traveltimeloadingmap.get(option.slug)
//   }
//   return result;
// }

function timeToMinutes(time: string): number {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
}

function minutesToTime(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
}

// function findViableGap(
//   start: string, 
//   bookings: Booking[], 
//   recommendedtime: number, 
//   bookingid: string | null, 
//   gapdirection: 'left' | 'right' | null
// ): string | null {
//   const workingStart = timeToMinutes('09:00');
//   const workingEnd = timeToMinutes('19:00');
//   const requiredStart = timeToMinutes(start);
//   const requiredEnd = requiredStart + recommendedtime;

//   if (requiredEnd > workingEnd) {
//     return null; // Booking extends beyond working hours
//   }

//   // Convert booking times to minutes
//   const convertedBookings = bookings.map(booking => ({
//     id: booking.id,
//     start: timeToMinutes(moment(booking.startdate).utc().format('HH:mm')),
//     end: timeToMinutes(moment(booking.enddate).utc().format('HH:mm'))
//   }));

//   // Sort bookings by start time
//   convertedBookings.sort((a, b) => a.start - b.start);

//   if (bookingid === null && gapdirection === null) {
//     // No boundary booking and direction provided, check from given start time until next booking or end of working hours
//     if (convertedBookings.length === 0) {
//       return requiredStart >= workingStart && requiredEnd <= workingEnd ? start : null;
//     }

//     // Check if there is a gap between the start time and the first booking
//     if (requiredStart < convertedBookings[0].start) {
//       if (convertedBookings[0].start - requiredStart >= recommendedtime) {
//         return start;
//       }
//     }

//     return null;
//   }

//   const boundaryIndex = convertedBookings.findIndex(booking => booking.id === bookingid);
//   if (bookingid !== null && boundaryIndex === -1) {
//     return null;
//   }

//   if (gapdirection === 'left') {
//     // Check for gaps before the given booking

//     const boundaryBookingStart = convertedBookings[boundaryIndex].start;

//     // Check gap before the boundary booking starting from its start time
//     if (boundaryIndex === 0) {
//       return requiredEnd <= boundaryBookingStart ? minutesToTime(boundaryBookingStart - recommendedtime) : null;
//     }
//     else {
//       const endOfPreviousBooking = convertedBookings[boundaryIndex - 1].end;
//       if (boundaryBookingStart - endOfPreviousBooking >= recommendedtime) {
//         return minutesToTime(boundaryBookingStart - recommendedtime);
//       }
//     }
//   } else if (gapdirection === 'right') {
//     // Check for gaps after the given booking

//     const boundaryBookingEnd = convertedBookings[boundaryIndex].end;
//     if(convertedBookings.length > boundaryIndex + 1) {
//       const startOfNextBooking = convertedBookings[boundaryIndex + 1].start;

//       if (startOfNextBooking - boundaryBookingEnd >= recommendedtime) {
//         return minutesToTime(boundaryBookingEnd);
//       }
//     }
//     else if(convertedBookings.length === boundaryIndex + 1) {
//       //Check gap after the last booking
//       const lastBookingEnd = convertedBookings[convertedBookings.length - 1].end;
//       if (boundaryBookingEnd >= lastBookingEnd && workingEnd - boundaryBookingEnd >= recommendedtime) {
//         return minutesToTime(boundaryBookingEnd);
//       }
//     }
//   }

//   return null;
// }

// async function googleTravelTime(from: string, to: string, mode: string): Promise<number> {
//   let result = 0;
//   if(from && to && mode) { 
//     await getDistanceMatrix({from: [from], to: [to], mode})
//     .then((res) => {
//       res?.rows?.forEach((r: DistanceMatrixRow) => {
//         r?.elements?.forEach((e: DistanceMatrixElement) => {
//           result = Math.round(e.duration.value / 60);
//           // Make sure minimum traveltime of 30 minutes is given
//           if(result < 30) result = 30;
//         })
//       })
//     });
//   }
//   return result;
// }

// function getLeftOrRight(tt: any) {
//   let val = 'none';
//   if(tt.to > 0 && tt.from > 0) {
//     val = 'both';
//   }
//   else if(tt.to > 0) {
//     val = 'left';
//   }
//   else if(tt.from > 0) {
//     val = 'right';
//   }
//   return val;
// }

// function prepareViableTimeGrapRespose(start: string, duration: number) {
//   return `${start} - ${minutesToTime(timeToMinutes(start) + duration)}`;
// }

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "card-header booking-section-header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (booking.value.appointmenttimeoutsidebooking)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("form", null, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", null, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: _inspector.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_inspector).value = $event)),
                    "track-by": "slug",
                    label: "name",
                    options: inspectorlist.value,
                    "allow-empty": true,
                    taggable: false,
                    disabled: disableddatewatch.value,
                    ref: el => { dynamicRefs.value['inspectorDropDown'] = el },
                    onOpen: _cache[2] || (_cache[2] = ($event: any) => (dropDownOpened('inspectorDropDown'))),
                    class: "no-padding",
                    onSearchChange: _cache[3] || (_cache[3] = ($event: any) => (inspectorsearchfilter.value = $event))
                  }, _createSlots({
                    singleLabel: _withCtx((props) => [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", {
                          class: _normalizeClass(getPiNameColClass(props.option))
                        }, _toDisplayString(props.option.name), 3),
                        _createElementVNode("div", _hoisted_13, [
                          (previousPI(props.option))
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16))
                            : _createCommentVNode("", true)
                        ]),
                        (getRating(props.option))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRating(props.option), (index) => {
                                return (_openBlock(), _createElementBlock("i", {
                                  key: index,
                                  class: "fas fa-star"
                                }))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    option: _withCtx((props) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["row", {
                          black: getRating(props.option) === 0,
                          red: getRating(props.option) === 1,
                          amber: getRating(props.option) == 2,
                          green: (getRating(props.option) > 2),
                          excluded: isPIExcludedOrPreferred(props.option) === 'excluded',
                          preferred: isPIExcludedOrPreferred(props.option) === 'preferred',
                        }])
                      }, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(props.option.name), 1),
                        _createElementVNode("div", _hoisted_19, [
                          (previousPI(props.option))
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_22))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          (getRating(props.option) > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                _hoisted_25,
                                _createElementVNode("strong", _hoisted_26, _toDisplayString(getRating(props.option)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(inspectorAreacount(props.option)), 1)
                        ])
                      ], 2)
                    ]),
                    _: 2
                  }, [
                    (_inspector.value && _inspector.value.slug)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _withModifiers(resetInspector, ["prevent","stop"]),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Who"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options", "disabled"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("form", null, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_singleselect_text, {
                      modelValue: _startdate.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_startdate).value = $event)),
                      options: starttimeoptions.value,
                      "allow-empty": true,
                      taggable: false,
                      ref: el => { dynamicRefs.value['startDateDropDown'] = el },
                      onOpen: _cache[6] || (_cache[6] = ($event: any) => (dropDownOpened('startDateDropDown'))),
                      class: _normalizeClass({
                        outline: booking.value.preferredduration > 0 || schedulealert.value,
                      }),
                      disabled: disableddatewatch.value
                    }, _createSlots({
                      singleLabel: _withCtx((props) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["row", {
                            'text-red': timeOutsideAgencyOpeningHours(props.option)
                          }])
                        }, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(customLabel(props.option)), 1)
                        ], 2)
                      ]),
                      option: _withCtx((props) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["row", {
                            'text-red': timeOutsideAgencyOpeningHours(props.option)
                          }])
                        }, [
                          _createElementVNode("div", _hoisted_33, _toDisplayString(customLabel(props.option)), 1)
                        ], 2)
                      ]),
                      _: 2
                    }, [
                      (_startdate.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_startdate.value = ''), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear Start Time"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options", "class", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_singleselect_text, {
                      modelValue: _enddate.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_enddate).value = $event)),
                      options: endtimeoptions.value,
                      "allow-empty": true,
                      taggable: false,
                      disabled: disableddatewatch.value,
                      ref: el => { dynamicRefs.value['endDateDropDown'] = el },
                      onOpen: _cache[9] || (_cache[9] = ($event: any) => (dropDownOpened('endDateDropDown'))),
                      class: _normalizeClass({
                        outline: booking.value.preferredduration > 0 || schedulealert.value,
                      })
                    }, _createSlots({
                      singleLabel: _withCtx((props) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["row", {
                            'text-red': timeOutsideAgencyOpeningHours(props.option)
                          }])
                        }, [
                          _createElementVNode("div", _hoisted_35, _toDisplayString(customLabel(props.option)), 1)
                        ], 2)
                      ]),
                      option: _withCtx((props) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["row", {
                            'text-red': timeOutsideAgencyOpeningHours(props.option)
                          }])
                        }, [
                          _createElementVNode("div", _hoisted_36, _toDisplayString(customLabel(props.option)), 1)
                        ], 2)
                      ]),
                      _: 2
                    }, [
                      (_enddate.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[7] || (_cache[7] = _withModifiers(($event: any) => {_enddate.value = ''; clearPreferredduration()}, ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear End Time"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options", "disabled", "class"])
                  ])
                ]),
                (booking.value.preferredduration > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      (recommendedtime.value > booking.value.preferredduration)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Recommended time overridden. " + _toDisplayString(_preferredduration.value) + " short. ", 1))
                        : _createCommentVNode("", true),
                      (recommendedtime.value < booking.value.preferredduration)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, " Recommended time overridden. Additional " + _toDisplayString(_preferredduration.value) + " given. ", 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("form", null, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control height-43",
                      value: _recommendedtime.value,
                      disabled: "true"
                    }, null, 8, _hoisted_45)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("form", null, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", {
                    class: _normalizeClass({'col-md-12': _appointmenttime.value != 'No Tenant but Fixed Time', 'col-md-9 pr-0': _appointmenttime.value === 'No Tenant but Fixed Time'})
                  }, [
                    _createVNode(_component_singleselect_text, {
                      modelValue: _appointmenttime.value,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_appointmenttime).value = $event)),
                      options: appointmenttimeoptions.value,
                      customLabel: customLabel,
                      "allow-empty": true,
                      taggable: false,
                      disabled: disableddatewatch.value,
                      ref: el => { dynamicRefs.value['appointmentTimeDropDown'] = el },
                      onOpen: _cache[12] || (_cache[12] = ($event: any) => (dropDownOpened('appointmentTimeDropDown'))),
                      class: _normalizeClass({
                        outline:
                          booking.value.preferredappointmenttime > 0 || schedulealert.value,
                      })
                    }, _createSlots({
                      singleLabel: _withCtx((props) => [
                        _createElementVNode("div", {
                          class: _normalizeClass({
                            'text-green': isCustomerReportFlexOn(props.option),
                          })
                        }, _toDisplayString(props.option), 3)
                      ]),
                      option: _withCtx((props) => [
                        _createElementVNode("div", {
                          class: _normalizeClass({
                            'text-green': isCustomerReportFlexOn(props.option),
                          })
                        }, _toDisplayString(props.option), 3)
                      ]),
                      _: 2
                    }, [
                      (_recommendedtime.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (
                      clearPreferredappointmenttime()
                          ), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear Appointment Time"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options", "disabled", "class"])
                  ], 2),
                  (_appointmenttime.value === 'No Tenant but Fixed Time')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createElementVNode("div", {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (showFixedTimeModal())),
                          class: "btn btn-outline-primary",
                          title: ""
                        }, _hoisted_52)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (booking.value.preferredappointmenttime > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, " Overriding appointment time " + _toDisplayString(recommendedappointmenttimeAsHHMM.value), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      (false && traveltime.value && (traveltime.value.from || traveltime.value.to))
        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  (inspector.value.transport)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                        (inspector.value.transport === 'Bike')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_60))
                          : (inspector.value.transport === 'Car')
                            ? (_openBlock(), _createElementBlock("i", _hoisted_61))
                            : (inspector.value.transport === 'Train')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_62))
                              : (inspector.value.transport === 'Walking')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_63))
                                : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  (
                  traveltime.value.fromfirstleg &&
                  traveltime.value.fromsecondleg &&
                  traveltime.value.fromthirdleg
                )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_65, [
                        _createElementVNode("i", {
                          class: "fas fa-home ml-1 mr-1",
                          "data-tooltip": traveltime.value.frompostcodes[0],
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (copyToClipboard(traveltime.value.frompostcodes[0])))
                        }, null, 8, _hoisted_66),
                        _hoisted_67,
                        _createElementVNode("span", _hoisted_68, _toDisplayString(traveltime.value.fromfirstlegduration), 1),
                        _hoisted_69,
                        _createElementVNode("i", {
                          class: "fas fa-building ml-1 mr-1",
                          "data-tooltip": traveltime.value.frompostcodes[1],
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (copyToClipboard(traveltime.value.frompostcodes[1])))
                        }, null, 8, _hoisted_70),
                        _hoisted_71,
                        _createElementVNode("span", _hoisted_72, _toDisplayString(traveltime.value.fromsecondlegduration), 1),
                        _hoisted_73,
                        _createElementVNode("i", {
                          class: "fas fa-building ml-1 mr-1",
                          "data-tooltip": traveltime.value.frompostcodes[2],
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (copyToClipboard(traveltime.value.frompostcodes[2])))
                        }, null, 8, _hoisted_74),
                        _hoisted_75,
                        _createElementVNode("span", _hoisted_76, _toDisplayString(traveltime.value.fromthirdlegduration), 1),
                        _hoisted_77
                      ]))
                    : (traveltime.value.fromfirstleg && traveltime.value.fromsecondleg)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_78, [
                          _createElementVNode("i", {
                            class: "fas fa-home ml-1 mr-1",
                            "data-tooltip": traveltime.value.frompostcodes[0],
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (copyToClipboard(traveltime.value.frompostcodes[0])))
                          }, null, 8, _hoisted_79),
                          _hoisted_80,
                          _createElementVNode("span", _hoisted_81, _toDisplayString(traveltime.value.fromfirstlegduration), 1),
                          _hoisted_82,
                          _createElementVNode("i", {
                            class: "fas fa-building ml-1 mr-1",
                            "data-tooltip": traveltime.value.frompostcodes[1],
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (copyToClipboard(traveltime.value.frompostcodes[1])))
                          }, null, 8, _hoisted_83),
                          _hoisted_84,
                          _createElementVNode("span", _hoisted_85, _toDisplayString(traveltime.value.fromsecondlegduration), 1),
                          _hoisted_86
                        ]))
                      : (traveltime.value.from)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_87, [
                            _createElementVNode("i", {
                              class: "fas fa-home ml-1 mr-1",
                              "data-tooltip": traveltime.value.frompostcodes[0],
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (copyToClipboard(traveltime.value.frompostcodes[0])))
                            }, null, 8, _hoisted_88),
                            _hoisted_89,
                            _createElementVNode("span", _hoisted_90, _toDisplayString(traveltime.value.fromduration), 1),
                            _hoisted_91
                          ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("span", {
                    class: "fas fa-stack fa-2x",
                    "data-tooltip": booking.value.address.postcode,
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (copyToClipboard(booking.value.address.postcode)))
                  }, _hoisted_96, 8, _hoisted_93)
                ]),
                _createElementVNode("div", _hoisted_97, [
                  (
                  traveltime.value.tofirstleg &&
                  traveltime.value.tosecondleg &&
                  traveltime.value.tothirdleg
                )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_98, [
                        _hoisted_99,
                        _createElementVNode("span", _hoisted_100, _toDisplayString(traveltime.value.tofirstlegduration), 1),
                        _hoisted_101,
                        _createElementVNode("i", {
                          class: "fas fa-building ml-1 mr-1",
                          "data-tooltip": traveltime.value.topostcodes[1],
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (copyToClipboard(traveltime.value.topostcodes[1])))
                        }, null, 8, _hoisted_102),
                        _hoisted_103,
                        _createElementVNode("span", _hoisted_104, _toDisplayString(traveltime.value.tosecondlegduration), 1),
                        _hoisted_105,
                        _createElementVNode("i", {
                          class: "fas fa-building ml-1 mr-1",
                          "data-tooltip": traveltime.value.topostcodes[2],
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (copyToClipboard(traveltime.value.topostcodes[2])))
                        }, null, 8, _hoisted_106),
                        _hoisted_107,
                        _createElementVNode("span", _hoisted_108, _toDisplayString(traveltime.value.tothirdlegduration), 1),
                        _hoisted_109,
                        _createElementVNode("i", {
                          class: "fas fa-home ml-1 mr-1",
                          "data-tooltip": traveltime.value.topostcodes[3],
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (copyToClipboard(traveltime.value.topostcodes[3])))
                        }, null, 8, _hoisted_110)
                      ]))
                    : (traveltime.value.tofirstleg && traveltime.value.tosecondleg)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_111, [
                          _hoisted_112,
                          _createElementVNode("span", _hoisted_113, _toDisplayString(traveltime.value.tofirstlegduration), 1),
                          _hoisted_114,
                          _createElementVNode("i", {
                            class: "fas fa-building ml-1 mr-1",
                            "data-tooltip": traveltime.value.topostcodes[1],
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (copyToClipboard(traveltime.value.topostcodes[1])))
                          }, null, 8, _hoisted_115),
                          _hoisted_116,
                          _createElementVNode("span", _hoisted_117, _toDisplayString(traveltime.value.tosecondlegduration), 1),
                          _hoisted_118,
                          _createElementVNode("i", {
                            class: "fas fa-home ml-1 mr-1",
                            "data-tooltip": traveltime.value.topostcodes[2],
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (copyToClipboard(traveltime.value.topostcodes[2])))
                          }, null, 8, _hoisted_119)
                        ]))
                      : (traveltime.value.to)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_120, [
                            _hoisted_121,
                            _createElementVNode("span", _hoisted_122, _toDisplayString(traveltime.value.toduration), 1),
                            _hoisted_123,
                            _createElementVNode("i", {
                              class: "fas fa-home ml-1 mr-1",
                              "data-tooltip": traveltime.value.topostcodes[1],
                              onClick: _cache[26] || (_cache[26] = ($event: any) => (copyToClipboard(traveltime.value.topostcodes[1])))
                            }, null, 8, _hoisted_124)
                          ]))
                        : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_125, [
                _createElementVNode("div", _hoisted_126, [
                  (traveltime.value.from)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                        _createTextVNode(_toDisplayString(`Total time to travel from previous property: ${traveltime.value.fromduration}`) + " ", 1),
                        (traveltime.value.fromdifference != 0)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass({
                    'text-danger': traveltime.value.fromdifference < 0,
                    'text-success': traveltime.value.fromdifference > 0,
                  })
                            }, "(" + _toDisplayString(traveltime.value.fromdifferenceduration) + ") ", 3))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_128,
                (traveltime.value.to)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                      (traveltime.value.to)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                            _createTextVNode(_toDisplayString(`Total time to travel to next property: ${traveltime.value.toduration}`) + " ", 1),
                            (traveltime.value.todifference != 0)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass({
                    'text-danger': traveltime.value.todifference < 0,
                    'text-success': traveltime.value.todifference > 0,
                  })
                                }, "(" + _toDisplayString(traveltime.value.todifferenceduration) + ") ", 3))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(BookingFixedTimeModal, {
      id: "fixedtime-booking-modal",
      ref_key: "bookingFixedTimeModal",
      ref: bookingFixedTimeModal
    }, null, 512)
  ]))
}
}

})